<template>
  <div class="container text-center">
    <Errors :errors="errors" />
    <br>

    <div class="input-group mb-3">
      <div class="custom-file">
        <input
          id="file-input"
          type="file"
          class="custom-file-input"
          accept="image/*"
          @change="uploadImage"
        >
        <label
          class="custom-file-label"
          for="file-input"
        >{{ $t('lang.image.upload_image') }}</label>
      </div>
    </div>

    <div
      v-if="imageUpload"
      class="container"
    >
      <vue-croppie
        ref="croppieRef"
        :enable-orientation="true"
        :enable-resize="false"
        :viewport="{ width: 200, height: 200, type: 'circle' }"
        @result="result"
        @update="update"
      />

      <div
        class="btn-group"
        style="margin-bottom: 20px"
      >
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          @click="bind()"
        >
          {{ $t('lang.image.reload') }}
        </button>
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          @click="rotate(-90)"
        >
          {{ $t('lang.image.rotate') }}<i class="icon-cw" />
        </button>
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          @click="rotate(90)"
        >
          {{ $t('lang.image.rotate') }}<i class="icon-ccw" />
        </button>
        <!--<button type="button" class="btn btn-outline-primary btn-sm" @click="crop()">
          {{ $t('lang.image.preview') }}
        </button>-->
      </div>

      <!--            <img v-if="cropped" v-bind:src="cropped" class="profile-image">-->

      <div class="modal-footer text-center">
        <button
          class="btn btn_1 btn-sm"
          data-dismiss="modal"
          @click="saveCrop()"
        >
          {{ $t('lang.forms.button_save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Errors from '../components/Alerts/Errors';

export default {
  name: 'CropProfileImage',

  components: {
    Errors,
  },

  data() {
    return {
      cropped: null,
      imageUpload: false,
      image: null,
      options: {
        format: 'jpeg',
        circle: true,
      },
      errors: {},
    };
  },

  methods: {
    bind() {
      this.$refs.croppieRef.bind({
        url: this.image,
      });
    },
    // CALBACK USAGE
    crop() {
      this.$refs.croppieRef.result(this.options, (output) => {
        this.cropped = output;
      });
    },
    result(output) {
      this.cropped = output;
    },
    rotate(rotationAngle) {
      // Rotates the image
      this.$refs.croppieRef.rotate(rotationAngle);
    },

    saveCrop() {
      this.$refs.croppieRef.result(this.options, (output) => {
        this.$emit('update', output);
      });
    },

    uploadImage(e) {
      const fileInput = document.getElementById('file-input');
      const filePath = fileInput.value;
      const allowedExtensions = /(.jpg|.jpeg|.png|.gif)$/i;

      if (!allowedExtensions.exec(filePath)) {
        this.errors = { image: [this.$t('lang.alerts.image_ext_error')] };
        fileInput.value = '';
        return false;
      }
      // Image preview
      this.errors = {};

      const fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      this.imageUpload = true;

      fileReader.onload = (e) => {
        const { result } = e.target;
        this.image = result;
        this.bind();
      };
    },
  },

};
</script>

<style scoped>

</style>
